import { FieldTemplateRegistry } from "@graffer-inc/form-generator";
import {
  InputElementUnion,
  isFormulaResultElement,
} from "@graffer-inc/form-schema";
import {
  ApplicantSchemaKeys,
  ReservedApplicantIdHelper,
} from "@graffer-inc/cloud-gov-core";
import { DefaultConfirmFieldTemplateRegistry } from "@graffer-inc/form-generator";

export class SmartApplyConfirmFieldRegistry implements FieldTemplateRegistry {
  constructor(private readonly applicantSchemaKeys: ApplicantSchemaKeys) {}
  get(elem: InputElementUnion) {
    if (
      ReservedApplicantIdHelper.isApplicantEmail(
        elem.id,
        this.applicantSchemaKeys,
      )
    ) {
      // 「自動入力」タグを付与する
      return DefaultConfirmFieldTemplateRegistry.getReadOnly({
        displayAutoSetTags: true,
      });
    }
    if (
      // 「自動入力」タグは付与しない
      ReservedApplicantIdHelper.isApplicantType(
        elem.id,
        this.applicantSchemaKeys,
      ) ||
      isFormulaResultElement(elem)
    ) {
      return DefaultConfirmFieldTemplateRegistry.getReadOnly();
    }
    return DefaultConfirmFieldTemplateRegistry.get();
  }
}
